export default __webpack_public_path__ + "static/media/i-telefone.322b548c.png";